'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('InspirationsManageCtrl', InspirationsManageCtrl);

  InspirationsManageCtrl.$inject = ['$log', '$q', '$sce', 'inspirations', 'inspirationSvc', 'NotifyingSvc', '$translate', 'userSvc'];

  /* @ngInject */
  function InspirationsManageCtrl($log, $q, $sce, inspirations, inspirationSvc, NotifyingSvc, $translate, userSvc) {
    var vm = this;
    vm.title = 'InspirationsManageCtrl';
    vm.newInspiration = {};
    vm.changeStatus = changeStatus;

    userSvc.getUser().then(function (user) {
      vm.disabledInspirationSharing = !user.organization.enableSharedInspirations;
      if (vm.disabledInspirationSharing) {
        $q.all([$translate('vnext.inspirations.disabledSharing.messageLeader'), $translate('vnext.inspirations.disabledSharing.message', { provider: '<i>' + user.organization.name + '</i>' })]).then(function (translatedStrings) {
          vm.disabledSharingMessage = $sce.trustAsHtml('<b>' + translatedStrings[0] + '</b> ' + translatedStrings[1]);
        });
      }
    });

    vm.inspirationStates = {
      'DRAFT': {
        name: 'vnext.inspirations.manage.draft.name',
        actionText: 'vnext.inspirations.manage.draft.text',
        next: 'REVIEW',
        icon: 'incognito'
      },
      'PUBLISHED': {
        name: 'vnext.inspirations.manage.public.name',
        actionText: 'vnext.inspirations.manage.public.text',
        next: 'INACTIVE',
        icon: 'usergroup'
      },
      'REVIEW': {
        name: 'vnext.inspirations.manage.review.name',
        actionText: 'vnext.inspirations.manage.review.text',
        next: 'DRAFT',
        icon: 'incognito'
      },
      'DELETED': {
        name: 'vnext.inspirations.manage.deleted.name',
        icon: 'incognito',
        actionText: 'vnext.inspirations.manage.deleted.text'
      },
      'INACTIVE': {
        name: 'vnext.inspirations.manage.inactive.name',
        actionText: 'vnext.inspirations.manage.inactive.text',
        next: 'PUBLISHED',
        icon: 'incognito'
      }
    };

    activate();

    ////////////////

    vm.openConfirmDeleteModal = function (inspiration) {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
        templateUrl: 'vnext/templates/modal-confirm.html',
        controller: 'ConfirmModalCtrl',
        inputs: {
          heading: $translate.instant('vnext.inspirations.deleteModal.title'),
          body: [$translate.instant('vnext.inspirations.deleteModal.message-1'), $translate.instant('vnext.inspirations.deleteModal.message-2')],
          focusableId: '',
          deletionFlow: ''
        },
        closeCallback: function closeCallback(result) {
          if (result) {
            deleteInspirationAndRefreshUploadedList(inspiration);
          }
        }
      });
    };

    function deleteInspirationAndRefreshUploadedList(inspiration) {
      inspirationSvc.delete(inspiration).then(function () {
        inspirationSvc.getType('uploaded').then(function (inspirations) {
          // talk about callback hell!
          vm.inspirations = inspirations;
        });
      });
    }

    function activate() {
      $log.debug('Inspirations manage control activate');
      vm.inspirations = inspirations;
    }

    function changeStatus(inspiration) {
      var nextStatus = vm.inspirationStates[inspiration.status].next;
      if (!nextStatus) {
        return;
      }
      inspiration.status = nextStatus;
      inspirationSvc.update(inspiration);
    }
  }
})();